import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './translator/en.json';
import fiTranslation from './translator/fi.json';
import sweTranslation from './translator/swe.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      fi: { translation: fiTranslation },
      swe: { translation: sweTranslation }
    },
    lng: 'fi', // Default language
    fallbackLng: 'fi', // Fallback language
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

const storedLanguage = localStorage.getItem('defaultLanguage');
i18n.changeLanguage(storedLanguage);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();